import Vue from 'vue';
import { MutationTree } from 'vuex';
import { DestinationsState } from './types';

export const mutations: MutationTree<DestinationsState> = {
    setDestinations(state, payload) {
        state.destinations = payload.destinations;
        console.log('set destinations', state.destinations);
    },

    setSelected(state, payload) {
        //Vue.set(state, "selected", payload);
        state.selected = payload;
        console.log('set selected', state.selected);
    },

    resetSelection(state) {
        state.selected = null;
        console.log('reset selection', state.selected);
    },

    destinationCreated(state, payload) {
        console.log('destination created');
    },

    destinationUpdated(state, payload) {
        console.log('destination updated');
    },
};
